import Category from "./Category";

import AlvikDrive from "./blocks/AlvikDrive"
import AlvikLED from "./blocks/AlvikLED"
import AlvikMove from "./blocks/AlvikMove"
import AlvikRotate from "./blocks/AlvikRotate"
import AlvikServo from "./blocks/AlvikServo"
import AlvikSetWheelSpeed from "./blocks/AlvikSetWheelSpeed"
import StopAlvik from "./blocks/StopAlvik"
import alvikbatterycharge from "./blocks/alvikbatterycharge"
import AlvikButtonPress from "./blocks/AlvikButtonPress"
import AlvikCalibrateColorSensor from "./blocks/AlvikCalibrateColorSensor"
import AlvikFarbsensor from "./blocks/AlvikFarbsensor"
import Alvikfarbsensorlabel from "./blocks/Alvikfarbsensorlabel"
import AlvikGetOrientation from "./blocks/AlvikGetOrientation"
import AlvikGetToFDistance from "./blocks/AlvikGetToFDistance"
import AlvikLineSensor from "./blocks/AlvikLineSensor"
import AlvikOn from "./blocks/AlvikOn"
import booleanBlock from "./blocks/booleanBlock"
import delay from "./blocks/delay"
import If_block from "./blocks/If_block"
import repeat_forever from "./blocks/repeat_forever"
import repeat_until from "./blocks/repeat_until"
import Start from "./blocks/Start"
import LogicInverter from "./blocks/LogicInverter"
import logic_operators from "./blocks/logic_operators"
import MathOperators from "./blocks/MathOperators"
import Number from "./blocks/Number"

export function getCategories() {
    return [
        new Category("Bewegung", "#00A5E3", [
            AlvikDrive,
            AlvikLED,
            AlvikMove,
            AlvikRotate,
            AlvikServo,
            AlvikSetWheelSpeed,
            StopAlvik
        ]),
        new Category("Sensoren", "#8DD7BF", [
            alvikbatterycharge,
            AlvikButtonPress,
            AlvikCalibrateColorSensor,
            AlvikFarbsensor,
            Alvikfarbsensorlabel,
            AlvikGetOrientation,
            AlvikGetToFDistance,
            AlvikLineSensor,
            AlvikOn
        ]),
        new Category("Steuerung", "#FF60A8", [
            booleanBlock,
            delay,
            If_block,
            repeat_forever,
            repeat_until,
            Start
        ]),
        new Category("Operatoren", "#FF5768", [
            LogicInverter,
            logic_operators,
            MathOperators
        ]),
        new Category("Mathe", "#FFBF65", [
            Number
        ]),
    ]
}